import { buildHowToSchema } from "@/lib/schemaBuilders";

/**
 * HowTo JSON-LD for the "How to actually support your gut" steps on
 * /blog/gut-healing-supplements-research-guide. Passed to <BlogPost
 * extraSchema={[...]}>. BlogPost emits BlogPosting + FAQPage from the DB content;
 * this adds the HowTo it doesn't derive on its own. The static prerender stub
 * (scripts/gut-guide-prerender.mjs) bakes the equivalent for non-JS crawlers.
 */
export const GUT_GUIDE_HOWTO_SCHEMA = buildHowToSchema({
  name: "How to actually support your gut (evidence-first)",
  description:
    "An evidence-first checklist: remove the damage, fix the diet base, use the supplements with real human data, match the probiotic strain, and get bloodwork if something is off.",
  steps: [
    { name: "Remove the damage", text: "Cut chronic NSAIDs where possible, keep alcohol moderate, do not smoke, and rule out H. pylori if you have symptoms." },
    { name: "Fix the diet base", text: "Feed soluble fiber (not bran) and add fermented foods; if you have IBS, trial low-FODMAP properly." },
    { name: "Use supplements with real data", text: "Zinc-L-carnosine for the lining, enteric-coated peppermint oil for IBS, and L-glutamine if you actually have measured permeability." },
    { name: "Match the probiotic strain", text: "Match the strain to the problem instead of buying a generic megadose." },
    { name: "Get bloodwork if something is off", text: "Unexplained low ferritin or B12 is a reason to test for autoimmune gastritis, not to guess with acid supplements." },
  ],
}) as Record<string, unknown>;
